var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0662 6.74585C11.7441 6.74585 11.4829 7.00702 11.4829 7.32918V49.3292C11.4829 49.6514 11.7441 49.9125 12.0662 49.9125H44.7329C45.0551 49.9125 45.3162 49.6514 45.3162 49.3292V7.32918C45.3162 7.00702 45.0551 6.74585 44.7329 6.74585H12.0662ZM7.98291 7.32918C7.98291 5.07402 9.81108 3.24585 12.0662 3.24585H44.7329C46.9881 3.24585 48.8162 5.07402 48.8162 7.32918V49.3292C48.8162 51.5843 46.9881 53.4125 44.7329 53.4125H12.0662C9.81108 53.4125 7.98291 51.5843 7.98291 49.3292V7.32918Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1496 16.6625C23.1496 15.696 23.9331 14.9125 24.8996 14.9125H38.8996C39.8661 14.9125 40.6496 15.696 40.6496 16.6625C40.6496 17.629 39.8661 18.4125 38.8996 18.4125H24.8996C23.9331 18.4125 23.1496 17.629 23.1496 16.6625Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1496 28.3292C23.1496 27.3627 23.9331 26.5792 24.8996 26.5792H38.8996C39.8661 26.5792 40.6496 27.3627 40.6496 28.3292C40.6496 29.2957 39.8661 30.0792 38.8996 30.0792H24.8996C23.9331 30.0792 23.1496 29.2957 23.1496 28.3292Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1496 39.9959C23.1496 39.0294 23.9331 38.2459 24.8996 38.2459H38.8996C39.8661 38.2459 40.6496 39.0294 40.6496 39.9959C40.6496 40.9623 39.8661 41.7459 38.8996 41.7459H24.8996C23.9331 41.7459 23.1496 40.9623 23.1496 39.9959Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8996 18.9959C19.1883 18.9959 20.2329 17.9512 20.2329 16.6625C20.2329 15.3738 19.1883 14.3292 17.8996 14.3292C16.6109 14.3292 15.5662 15.3738 15.5662 16.6625C15.5662 17.9512 16.6109 18.9959 17.8996 18.9959Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8996 30.6625C19.1883 30.6625 20.2329 29.6179 20.2329 28.3292C20.2329 27.0405 19.1883 25.9959 17.8996 25.9959C16.6109 25.9959 15.5662 27.0405 15.5662 28.3292C15.5662 29.6179 16.6109 30.6625 17.8996 30.6625Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8996 42.3292C19.1883 42.3292 20.2329 41.2846 20.2329 39.9959C20.2329 38.7072 19.1883 37.6625 17.8996 37.6625C16.6109 37.6625 15.5662 38.7072 15.5662 39.9959C15.5662 41.2846 16.6109 42.3292 17.8996 42.3292Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewList);
export default __webpack_public_path__ + "static/media/view-list.72dee975.svg";
export { ForwardRef as ReactComponent };